var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        {
          staticClass: "card-bg-2 headline pb-0",
          class: { "grey--text": _vm.disabled },
          staticStyle: { "align-items": "baseline", display: "flex" },
          attrs: { id: `step-${_vm.index} ` },
        },
        [
          _vm._v("\n    Date Range\n    "),
          _c(
            "v-menu",
            {
              attrs: { "offset-y": "", "open-on-hover": "", "open-delay": 400 },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        "v-icon",
                        _vm._g(
                          {
                            staticClass: "clickable ml-2",
                            attrs: { color: "primary" },
                            on: {
                              click: function ($event) {
                                _vm.showHelp = true
                              },
                            },
                          },
                          on
                        ),
                        [_vm._v("\n          info_outline\n        ")]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.showHelp,
                callback: function ($$v) {
                  _vm.showHelp = $$v
                },
                expression: "showHelp",
              },
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c("v-card-text", [
                    _vm._v(
                      " Available date range is the first and last records of the selected time series (or of all shown\n          time series if none selected). "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "card-bg-2 pb-0" },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  !_vm.disabled
                    ? _c(
                        "vc-date-picker",
                        {
                          attrs: {
                            mode: "range",
                            columns: 2,
                            "available-dates": { end: _vm.restrictions.end },
                            popover: { visibility: "click" },
                          },
                          model: {
                            value: _vm.dates,
                            callback: function ($$v) {
                              _vm.dates = $$v
                            },
                            expression: "dates",
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "min-width": "100px" },
                                  attrs: { md6: "" },
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "rounded-left",
                                    attrs: {
                                      label: _vm.prettyAvailableStart,
                                      "hide-details": "",
                                      solo: "",
                                      "prepend-inner-icon": "date_range",
                                      readonly: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.dates.start
                                          ? {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        bottom: "",
                                                        "open-delay": 500,
                                                        "close-delay": 0,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "ma-0 mr-1",
                                                          attrs: {
                                                            slot: "activator",
                                                            small: "",
                                                            icon: "",
                                                            disabled:
                                                              _vm.disabled ||
                                                              !_vm.dates.start,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.previousStartDate()
                                                            },
                                                          },
                                                          slot: "activator",
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "chevron_left"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Previous day"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        bottom: "",
                                                        "open-delay": 500,
                                                        "close-delay": 0,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "ma-0",
                                                          attrs: {
                                                            slot: "activator",
                                                            small: "",
                                                            icon: "",
                                                            disabled:
                                                              _vm.disabled ||
                                                              !_vm.hasNextStartDate ||
                                                              !_vm.dates.start,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.nextStartDate()
                                                            },
                                                          },
                                                          slot: "activator",
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "chevron_right"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Next day"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.prettyStartDate,
                                      callback: function ($$v) {
                                        _vm.prettyStartDate = $$v
                                      },
                                      expression: "prettyStartDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "min-width": "100px" },
                                  attrs: { md6: "" },
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "rounded-right",
                                    attrs: {
                                      label: _vm.prettyAvailableEnd,
                                      "hide-details": "",
                                      solo: "",
                                      readonly: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.dates.end
                                          ? {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        bottom: "",
                                                        "open-delay": 500,
                                                        "close-delay": 0,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "ma-0 mr-1",
                                                          attrs: {
                                                            slot: "activator",
                                                            small: "",
                                                            icon: "",
                                                            disabled:
                                                              _vm.disabled ||
                                                              !_vm.dates.end,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.previousEndDate()
                                                            },
                                                          },
                                                          slot: "activator",
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "chevron_left"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Previous day"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        bottom: "",
                                                        "open-delay": 500,
                                                        "close-delay": 0,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "ma-0 mr-1",
                                                          attrs: {
                                                            slot: "activator",
                                                            small: "",
                                                            icon: "",
                                                            disabled:
                                                              _vm.disabled ||
                                                              !_vm.hasNextEndDate ||
                                                              !_vm.dates.end,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.nextEndDate()
                                                            },
                                                          },
                                                          slot: "activator",
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "chevron_right"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Next day"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.prettyEndDate,
                                      callback: function ($$v) {
                                        _vm.prettyEndDate = $$v
                                      },
                                      expression: "prettyEndDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : [
                        _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              {
                                staticStyle: { "min-width": "100px" },
                                attrs: { md6: "" },
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "rounded-left",
                                  attrs: {
                                    disabled: "",
                                    label: _vm.prettyAvailableStart,
                                    "hide-details": "",
                                    solo: "",
                                    "prepend-inner-icon": "date_range",
                                    readonly: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      _vm.dates.start
                                        ? {
                                            key: "append",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "ma-0 mr-1",
                                                    attrs: {
                                                      small: "",
                                                      icon: "",
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("chevron_left"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "ma-0",
                                                    attrs: {
                                                      small: "",
                                                      icon: "",
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("chevron_right"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          }
                                        : null,
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.prettyStartDate,
                                    callback: function ($$v) {
                                      _vm.prettyStartDate = $$v
                                    },
                                    expression: "prettyStartDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticStyle: { "min-width": "100px" },
                                attrs: { md6: "" },
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "rounded-right",
                                  attrs: {
                                    disabled: "",
                                    label: _vm.prettyAvailableEnd,
                                    "hide-details": "",
                                    solo: "",
                                    readonly: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      _vm.dates.end
                                        ? {
                                            key: "append",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "ma-0 mr-1",
                                                    attrs: {
                                                      small: "",
                                                      icon: "",
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("chevron_left"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "ma-0 mr-1",
                                                    attrs: {
                                                      small: "",
                                                      icon: "",
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("chevron_right"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          }
                                        : null,
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.prettyEndDate,
                                    callback: function ($$v) {
                                      _vm.prettyEndDate = $$v
                                    },
                                    expression: "prettyEndDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-menu",
                { attrs: { disabled: _vm.disabled, "offset-y": "" } },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        slot: "activator",
                        bottom: "",
                        "open-delay": 500,
                        "close-delay": 0,
                      },
                      slot: "activator",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "dropdown-btn mr-0",
                          attrs: { slot: "activator", depressed: "" },
                          slot: "activator",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "success--text subheading text-capitalize",
                            },
                            [
                              _vm._v("\n              Show\n              "),
                              _c("span", { staticClass: "text-lowercase" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.selectedRange) +
                                    "\n              "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-icon", [_vm._v("arrow_drop_down")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Date range shortcuts")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _vm._l(_vm.shortcuts, function (item, index) {
                        return [
                          item.divider
                            ? _c("v-divider", { key: index })
                            : _c(
                                "v-list-tile",
                                { key: index, on: { click: item.action } },
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(_vm._s(item.title)),
                                  ]),
                                ],
                                1
                              ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.dates.start && _vm.dates.end
                ? _c(
                    "v-tooltip",
                    {
                      attrs: {
                        bottom: "",
                        "open-delay": 500,
                        "close-delay": 0,
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            slot: "activator",
                            disabled: _vm.disabled,
                            icon: "",
                            depressed: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onShortcut(_vm.shortcutTypes.all)
                            },
                          },
                          slot: "activator",
                        },
                        [
                          _c("v-icon", [
                            _vm._v("\n            clear\n          "),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Clear date range filter")]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "pt-3 pb-4" },
            [
              _c("v-flex", { staticClass: "text-xs-center caption" }, [
                _vm._v(
                  "\n        Available data from\n        " +
                    _vm._s(_vm.prettyDate(_vm.availableDateRange.start)) +
                    " –\n        " +
                    _vm._s(_vm.prettyDate(_vm.availableDateRange.end)) +
                    "\n      "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }